import { combineReducers } from "redux";
import {
  FETCH_SOCIAL,
  LOAD_EDIT_SOCIAL_DATA,
  OPEN_SOCIAL_MODAL,
  IS_INSTAGRAM_LOADER_OPEN,
} from "ActionsSocial";

export function SocialReducers(state = [], action) {
  switch (action.type) {
    case FETCH_SOCIAL:
      return action.payload.resource;
    default:
      return state;
  }
}

export function loadEditSocialData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_SOCIAL_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function openSocialPopup(state = [], action) {
  switch (action.type) {
    case OPEN_SOCIAL_MODAL:
      return action.payload;
    default:
      return state;
  }
}

// Show loader while instagram is connecting
export var isOpenInstaLoader = (state = false, action) => {
  if (action.type === IS_INSTAGRAM_LOADER_OPEN) {
    state = action.payload;
  }
  return state;
};
